import { render, staticRenderFns } from "./SundryWasteList.vue?vue&type=template&id=0fd3d5b4&scoped=true&"
import script from "./SundryWasteList.vue?vue&type=script&lang=js&"
export * from "./SundryWasteList.vue?vue&type=script&lang=js&"
import style0 from "./SundryWasteList.vue?vue&type=style&index=0&id=0fd3d5b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd3d5b4",
  null
  
)

export default component.exports